import { TableContainer, TableContainerProps } from "@mui/material";
import { forwardRef } from "react";

export type SHTableContainerProps = TableContainerProps;
export const SHTableContainer = forwardRef(
  (props: SHTableContainerProps, ref: any): JSX.Element => (
    <TableContainer {...props} ref={ref} />
  ),
);
